import type { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useGetMyDocumentsQuery } from "../api/excelReportsApi";
import type { DomainDocumentItem } from "../api/types";
import { isEox7Forbidden } from "../utils/reportEox7Error";
import { listReportFiles } from "../utils/reportTreeItems";

const NO_FILES: DomainDocumentItem[] = [];

/**
 * The report files the picker shows, from the same `documents/me` query —
 * so a count or a search hit can't disagree with the tree.
 * A 403 means the caller has no reports here, not a failure.
 */
export function useExcelReportFiles(
	companyDomainId: string | typeof skipToken,
) {
	// WHY currentData: `data` keeps the previous domain's documents after a
	// domain switch (and through a 403 on the new one); `currentData` is only
	// ever this domain's.
	const { currentData, error, isFetching } =
		useGetMyDocumentsQuery(companyDomainId);
	const files = useMemo(
		() => (currentData ? listReportFiles(currentData.documents) : NO_FILES),
		[currentData],
	);
	return {
		files,
		isLoading: !currentData && isFetching,
		isError: Boolean(error) && !isEox7Forbidden(error),
	};
}
